export interface UserBaseInfo {
  guid: string;
  qua2: string;
  // 发起建单、领取赠品时需要用手机号绑定赠品信息，脱敏
  phone_num: string;
}

export interface AuthHeader {
  app_key: string;
  auth_token: string;
}

// 用户身份态相关信息
export interface Account {
  AccountType: number;
  TokenType: number;
  Openid: string;
  Token: string;
  Appid: string;
  Qbid: string;
}

export enum LOGINTYPE {
  QQ = 'qq',
  WECHAT = 'wx',
}
// 用户身份态相关信息
export interface AccountInfo {
  qbid: string;
  openid: string;
  logintype: LOGINTYPE;
  appid?: string;
  accessToken: string;
  logo: string;
  nickName: string;
  type?: number;
  uin?: string;
  token?: string;
};

export interface DeviceInfo {
  guid: string; // guid
  tguid: string; // guid
  qimei36: string; // qimei36
  qimei32: string; // qimei36
  qauth?: string; // qauth
  qua?: string; // qua
  qimei36Token?: string; // qimei36Token（12.0.5开始支持）
  qua2?: string; // qua2
  idfa?: string; // idfa
};

export interface GiftInfo {
  id: string; // 赠品id
  name: string; // 赠品名称
  wording: string; // 赠品描述信息
  iconUrl: string; // 赠品图标
  receiveUrl: string; // 领取url
  detailUrl: string; // 详情url
  orderId?: string; // 可能透传的订单id
}

export const defaultGiftInfo = {
  id: '',
  name: '',
  wording: '',
  iconUrl: '',
  receiveUrl: '',
  detailUrl: '',
};


export const defaultAccountInfo = {
  accessToken: '',
  qbid: '',
  openid: '',
  logintype: LOGINTYPE.QQ,
  logo: '',
  nickName: '',
};

export const defaultDeviceInfo = {
  guid: '', // guid
  tguid: '', // tguid
  qua: '', // qua
  qauth: '', // qauth
  qimei36: '', // qimei36
  qimei32: '', // qimei32
  qimei36Token: '', // qimei36Token（12.0.5开始支持）
};

export enum LoginType {
  QQ = 1,
  WX = 2,
  NOTLOGIN = 3,
  QQ_OPEN = 4,
  MOBILE = 6,
}

export enum Platform {
  DefaultPlatform = 0, // 默认平台
  AdrPlatform = 1, // 安卓平台
  IosPlatform = 2, // ios平台
  WinPlatform = 3, // win平台
  MacPlatform = 4, // mac平台
}

export interface IdcenterAccount {
  account_type: number;
  account_id: string; // 微信物联登录体系账号openId, qq
  appid: string; // appid
  extend?: Record<string, string>;
}

export interface IdcenterToken {
  token_type: number; // IdcenterTokenType
  token: string; // 票据
  extend?: Record<string, string>;
}


export interface UserAuthInfo {
  nick_name: string;
  account: IdcenterAccount;
  token: IdcenterToken;
}
